<template>
  <div class="main-content">
    <b-container class="mt-4">
      <b-row>
        <b-col>
          <img src="@/assets/logo.svg" fluid class="float-left mr-3" height="100"/>
          <h1 class="mt-3">Cloud Workplace Management</h1>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col class="lead">
          <p class="lead">CWM è disponibile per tutte le maggiori piattaforme:</p>
          <ul>
            <li>Android</li>
            <li>Apple iOS</li>
            <li>Microsoft Windows</li>
            <li>Apple Mac OSX</li>
          </ul>

          <p class="mb-2">Usa il badge qui in basso per scaricare quella di tuo interesse.</p>

          <hr>

          <b-row>
            <b-col>
              <a
                href='https://play.google.com/store/apps/details?id=it.ennova.cwm&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img
                alt='Disponibile su Google Play'
                src='https://play.google.com/intl/en_gb/badges/images/generic/it_badge_web_generic.png'
                width="240"/></a>
            </b-col>
            <b-col>
              <a href="https://itunes.apple.com/it/app/cloud-workplace-management/id1405656312?mt=8"
                 style="display:inline-block;overflow:hidden;background:url(https://linkmaker.itunes.apple.com/assets/shared/badges/it-it/appstore-lrg.svg) no-repeat;width:230px;height:90px;margin:15px;background-size:contain;"></a>
            </b-col>
          </b-row>

        </b-col>
        <b-col class="text-right">
          <img src="@/assets/smartmockups_jjty2ofs.jpg" alt="CWM" width="300" />
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
  export default {
    name: 'Download',
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Download.vue